export default "__VITE_ASSET__DEk9muck__"